import type { EditFormValues } from '../lib/types';
import { useUpdatePermissionTeamUpdatePermissionPostMutation } from '@shared/api';

export const useUpdateTeamMember = (organizationId: number) => {
  const [updateTeamMemberMutation, { isLoading }] =
    useUpdatePermissionTeamUpdatePermissionPostMutation();
  const updateTeamMember = async (teamMemberId: number, values: EditFormValues) => {
    try {
      await updateTeamMemberMutation({
        bodyUpdatePermissionTeamUpdatePermissionPost: {
          organization_id: organizationId,
          user_id: teamMemberId,
          permission: values?.permission,
        },
      }).unwrap();
    } catch {
      throw new Error();
    }
  };

  return { updateTeamMember, isLoading };
};
